import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private storage: Storage;

  constructor() {
    this.storage = localStorage;
  }

  public saveData(key: string, data: any, isJsonData: boolean = true): void {
    if (data) {
      if (!isJsonData) {
        this.storage.setItem(key, data);
      } else {
        this.storage.setItem(key, JSON.stringify(data));
      }
    }
  }


  public getData(key: string, isJson: boolean = true): any {
    const data = this.storage.getItem(key);
    if (data != null) {
      if (!isJson) {
        return data;
      } else {
        return JSON.parse(data);
      }
    }
    return null;
  }


  public removeData(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }
}
